import React from "react";
import styles from "./sideDrawer.module.scss";

const SideDrawerContents = ({ children }) => {
    return (
        <div className={styles.SideDrawerContents} >
            {children}
        </div>
    );
}

export default SideDrawerContents;